export default __webpack_public_path__ + "static/media/tedxmlrit.8cfc596b.jpg";